import { render, staticRenderFns } from "./NewslettersTable.vue?vue&type=template&id=3c8bb07e&"
import script from "./NewslettersTable.vue?vue&type=script&lang=js&"
export * from "./NewslettersTable.vue?vue&type=script&lang=js&"
import style0 from "./NewslettersTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports